export default __webpack_public_path__ + "ecd9a0bee76f26e87cfebc658da1d414.svg";